export const LoadingStates = Object.freeze({
    notLoaded: 'NOT_LOADED',
    loading: 'LOADING',
    loadingMore: 'LOADING_MORE',
    loaded: 'LOADED',
    error: 'ERROR',
});
